import { defineStore } from 'pinia';
import { AppHasMovedToTheBackgroundCommand } from 'src/stores/app/commands/AppHasMovedToTheBackgroundCommand';
import { AppHasMovedToTheForegroundCommand } from 'src/stores/app/commands/AppHasMovedToTheForegroundCommand';
import { NEVER_SHOW_INSTALL } from 'src/stores/app/localStorageKeys';

import type { AppMovedPayload, AppStoreState } from './interfaces';

const createDefaultState = (): AppStoreState => ({
	neverShowInstall:
		localStorage.getItem(NEVER_SHOW_INSTALL) !== null
			? /true/i.test(localStorage.getItem(NEVER_SHOW_INSTALL) as 'false' | 'true')
			: false,
});

export const useAppStore = defineStore('app', {
	actions: {
		appHasMovedToTheBackground(payload: AppMovedPayload): void {
			void payload.commandBus?.sendCommand(
				new AppHasMovedToTheBackgroundCommand(payload.platform, payload.browser, process.env.VERSION)
			);
		},
		appHasMovedToTheForeground(payload: AppMovedPayload): void {
			void payload.commandBus?.sendCommand(
				new AppHasMovedToTheForegroundCommand(payload.platform, payload.browser, process.env.VERSION)
			);
		},
		setNeverShowInstall(neverShowInstall: boolean): void {
			localStorage.setItem(NEVER_SHOW_INSTALL, String(neverShowInstall));
			this.neverShowInstall = neverShowInstall;
		},
	},
	state: createDefaultState,
});
export * from './interfaces';
export * from './types';
